module.exports = __webpack_public_path__ + "44d632a68853b6c01d99cbd5a40118f3.woff2";